<template>
  <v-container>
    <router-view />
  </v-container>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
